module.exports = __webpack_public_path__ + "img/FJ.92534c37.jpg";